<template>
  <div >
    <Header />
    <v-container style="padding:0px;">
      <v-card
        class="mx-auto my-12"
        style="margin-top: 15px !important;margin-bottom: 5px !important;max-width:100% !important;box-shadow:none;"
        max-width="374"
      >
        <v-img
          height="200"
          src="https://miro.medium.com/max/1200/1*U-G1yCK7UI3JESd1OJqMCw.gif"
        ></v-img>

        <v-card-text>
          <v-row> </v-row>
        </v-card-text>
      </v-card>
      <v-spacer></v-spacer>
      <div style="margin-top:2em;">
        <v-bottom-navigation
          grow
          style="-webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;"
        >
          <v-btn value="recent" cols="4"  @click="BarcodeReader()">
            <span>Camera Scan</span>

            <v-icon style="color: #1976d2;">mdi-barcode-scan</v-icon>
          </v-btn>
          <v-btn value="recent" cols="4" @click="pdt">
            <span>PDT Scan</span>

            <v-icon style="color: #1976d2;">mdi-barcode</v-icon>
          </v-btn>
          <v-btn value="favorites" cols="4"  @click="Printbarcode">
            <span>Print Barcode</span>

            <v-icon style="color: #1976d2;">mdi-printer</v-icon>
          </v-btn> 
        </v-bottom-navigation>
      </div>
        <div style="margin-top:2em;">
        <v-bottom-navigation
          grow
          style=" -webkit-box-shadow: none;-moz-box-shadow: none;
  box-shadow: none;"
        >
          <v-btn value="favorites" cols="4" @click="OpenCommonVoucher('GR')" v-if="IsShowGoodsReceipt===true">
            <span>Goods Receipt</span>

            <v-icon style="color: #1976d2;">mdi-store</v-icon>
          </v-btn>
          <v-btn value="nearby" cols="4" @click="OpenCommonVoucher('PS')" v-if="IsShowPhysicalStock===true">
            <span>Physical Stock</span>

            <v-icon style="color: #1976d2;">mdi-google-analytics</v-icon>
          </v-btn>
          <v-btn value="nearby" cols="4" @click="OpenCommonVoucher('SO')" v-if="IsShowSalesOrder===true">
            <span>Sales Order</span>

            <v-icon style="color: #1976d2;">mdi-cart</v-icon>
          </v-btn>
        </v-bottom-navigation>
        <v-dialog
    v-model="saledialog"
    width="auto"
  >
    <v-card>
      <v-card-text>
        <v-row no-gutters style="padding-top:10px;">
          <v-col cols style="justify-content:center;text-align: center;padding:5px;" >
            <v-card text="text-align:center;">
              <!-- {{ Allpermission }} -->
              <v-icon style="color: #1976d2;font-size: 2em;">mdi-cube</v-icon>
              <v-btn color="primary" block  @click="CheckSalesBarnch">Counter Sale</v-btn>
            </v-card>
           
          </v-col>
          <v-col cols style="justify-content:center;text-align: center;padding:5px;" >
            <v-card text="">
              <!-- {{ Counterpermission }} -->
              <v-icon style="color: #1976d2;font-size: 2em;">mdi-sale</v-icon>
            <v-btn color="primary" block @click="goSaleall">All Sale</v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      
    </v-card>
  </v-dialog>
  <v-dialog v-model="BranchModal" max-width="500px">
               <v-card>
                 <v-card-text style=" padding-top: 3em;">
                 <v-combobox
                  v-model="BranchCode"
                  :items="BranchCodeOptions"
                 label="Select Branch"
                 :disabled="IsDisableBarnch"
             
                 dense
                ></v-combobox>
                <!-- <v-text-field 
               disabled
                v-show="!notmorethan1"
                v-model="selected_branch"
                label="Select Branch"
                >
   
                </v-text-field> -->
                
     
                  
                 </v-card-text>
     
                 <v-card-actions>
                   <v-spacer></v-spacer>
     
                   <v-btn text color="primary" @click="GetBranchByBranchCode()">ok</v-btn>
                 </v-card-actions>
               </v-card>
             </v-dialog>
      </div>
      <div style="margin-top:2em;">
        <v-bottom-navigation
          grow
          style="-webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;"
        >
           <v-btn value="favorites" cols="4" @click="Preference">
            <span>Preferences</span>

            <v-icon style="color: #1976d2;">mdi-eye</v-icon>
          </v-btn>
            <!-- <v-btn value="nearby" cols="4">
            <span>Account</span>

            <v-icon style="color: #1976d2;">mdi-account</v-icon>
          </v-btn>  -->
         


          
          <v-btn value="nearby" cols="4" v-if="IsShowVoucherVerification" @click="OpenVerificationForm()">
            <span>Verification</span>

            <v-icon style="color: #1976d2;">mdi mdi-check-decagram</v-icon>
          </v-btn >
            <v-btn value="nearby" cols="4" @click="VoucherRegister" v-if="IsShowRegister===true">
            <span>Registers</span>

            <v-icon style="color: #1976d2;">mdi-view-list</v-icon>
          </v-btn>
    
        </v-bottom-navigation>
      </div>
    
         <div style="margin-top:2em;">
        <v-bottom-navigation
          grow
          style=" -webkit-box-shadow: none;-moz-box-shadow: none;
  box-shadow: none;"
        >
   
        
          <v-btn value="recent" cols="4"  @click="OpenSales()" v-if="IsShowSales===true">
            <span>Sales Report</span>

            <v-icon style="color: #1976d2;">mdi-clipboard-flow</v-icon>
          </v-btn>
  <!-- <v-btn value="nearby" cols="4" @click="VoucherRegister" v-if="IsShowRegister===true">
            <span>Registers</span>

            <v-icon style="color: #1976d2;">mdi-view-list</v-icon>
          </v-btn> -->
    
        </v-bottom-navigation>
        <v-dialog
    v-model="saledialog"
    width="auto"
  >
    <v-card>
      <v-card-text>
        <v-row no-gutters style="padding-top:10px;">
          <v-col cols style="justify-content:center;text-align: center;padding:5px;" >
            <v-card text="text-align:center;">
              <!-- {{ Allpermission }} -->
              <v-icon style="color: #1976d2;font-size: 2em;">mdi-cube</v-icon>
              <v-btn color="primary" block  @click="CheckSalesBarnch">Counter Sale</v-btn>
            </v-card>
           
          </v-col>
          <v-col cols style="justify-content:center;text-align: center;padding:5px;" >
            <v-card text="">
              <!-- {{ Counterpermission }} -->
              <v-icon style="color: #1976d2;font-size: 2em;">mdi-sale</v-icon>
            <v-btn color="primary" block @click="goSaleall">All Sale</v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      
    </v-card>
  </v-dialog>
  <v-dialog v-model="BranchModal" max-width="500px">
               <v-card>
                 <v-card-text style=" padding-top: 3em;">
                 <v-combobox
                  v-model="BranchCode"
                  :items="BranchCodeOptions"
                 label="Select Branch"
                 :disabled="IsDisableBarnch"
             
                 dense
                ></v-combobox>
                <!-- <v-text-field 
               disabled
                v-show="!notmorethan1"
                v-model="selected_branch"
                label="Select Branch"
                >
   
                </v-text-field> -->
                
     
                  
                 </v-card-text>
     
                 <v-card-actions>
                   <v-spacer></v-spacer>
     
                   <v-btn text color="primary" @click="GetBranchByBranchCode()">ok</v-btn>
                 </v-card-actions>
               </v-card>
             </v-dialog>
      </div>
    </v-container>
  
    <v-divider></v-divider>
        <v-dialog v-model="BarcodeModal" persistent width="500">
      <v-card>
        <v-card-title
          style="color:rgb(0 99 145);font-size:17px;text-align:center"
          >Scan barcode</v-card-title
        >

        <v-card-text>
          <StreamBarcodeReader
            @decode="a => onDecode(a)"
            @loaded="() => onLoaded()"
          ></StreamBarcodeReader>
        </v-card-text>
        <v-card-actions hidden>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="BarcodeModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>

          <v-btn
            small
            @click="BarcodeModal = false"
            style="background-color:#2E7D32;color:#FFF"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-menu v-model="GlobalPasswordModal">
     <globalpassword/>
        </v-menu>
  </div>
  </template>
  <script>
  import axios from "axios";
  import Header from "../Pages/Header.vue";
  import { StreamBarcodeReader } from "vue-barcode-reader";
  import globalpassword from "../Pages/Globalpassword.vue"
  export default {
    components: {
    Header,StreamBarcodeReader,globalpassword
  },
    data() {
      return {
        GlobalPasswordModal:false,
        bURL : localStorage.getItem('BaseURL'),
        saledialog:false,
        IsNativeFlutterApp:false,
        BranchCode : "",
        BranchCodeOptions:JSON.parse(localStorage.getItem('Branches')),
        BranchModal:false,
        IsPdt :false,
        IsPrintBarcode : false,
        Loaderdialog:false,
        PermissionObject : JSON.parse(localStorage.getItem('PermissionObject')),
        IsShowSales : false,
        IsShowPhysicalStock : false,
        IsShowSalesOrder : false,
        IsShowGoodsReceipt : false,
        IsShowAllSales:false,
        IsShowCounterSales:false,
        BarcodeModal:false,
        IsShowVoucherVerification:false,
        IsShowRegister:false,
      };
    },
    watch: {
    
    },
  
    mounted() {
      this.Token = localStorage.getItem('Token')
      if (this.Token === "" || this.Token === null || this.Token === undefined ) 
       {
        this.$router.push("login");
       }

       this.IsNativeFlutterApp = localStorage.getItem("IsNativeFlutterApp");
        if (this.IsNativeFlutterApp === "true" || this.IsNativeFlutterApp === true)
        {
          this.IsNativeFlutterApp = true
        }
        else
        {
          this.IsNativeFlutterApp = false
        }


        if(this.PermissionObject.includes('frmSaleReg') === true && this.PermissionObject.includes('frmCounterSaleSummary') === true )
        {
          this.IsShowSales = true
        }
         if(this.PermissionObject.includes('frmPhysicalStock') === true)
        {
          this.IsShowPhysicalStock = true
        }
         if(this.PermissionObject.includes('frmOrderForm') === true)
        {
          this.IsShowSalesOrder = true
        }
         if(this.PermissionObject.includes('frmGoodsReceipt') === true)
        {
          this.IsShowGoodsReceipt = true
        }
        if(this.PermissionObject.includes('frmVoucherVerification') === true)
        {
          this.IsShowVoucherVerification = true
        }
        if(this.IsShowVoucherVerification === true || this.IsShowGoodsReceipt === true || this.IsShowSalesOrder === true || this.IsShowPhysicalStock === true)
        {
          this.IsShowRegister = true
        }
       
            this.BranchCode = localStorage.getItem('SystemBranch')
            if(this.BranchCode === "#" || this.BranchCode === "" || this.BranchCode === "null" || this.BranchCode === null ||this.BranchCode === undefined)
            {
              
               this.UserDetails = JSON.parse(localStorage.getItem('User'))
               this.BranchCode = this.UserDetails.branchCode
               if(this.BranchCode === "#" || this.BranchCode === "" || this.BranchCode === "null" || this.BranchCode === null)
               {
                this.BranchCode = ''
               }
              else{
                  localStorage.setItem('SystemBranch',this.BranchCode)
                  this.GetBranchByBranchCode()
              }
            }
            else{
              this.PriceGroupId = localStorage.getItem('this.PriceGroupId')
            }
         
       
    },
  methods:{
   
    OpenCommonVoucher(type) {
      localStorage.removeItem('VoucherEditId')
      localStorage.setItem("VoucherType",type)
      this.$router.push("Voucher");
    },
    pdt()
    {
      this.BranchCode = localStorage.getItem('SystemBranch')
      this.UserObject = JSON.parse(localStorage.getItem('User')) 
     
      
            if((this.BranchCodeOptions.length > 1) &&(this.UserObject.userType === "Administrator" ||this.UserObject.branchCode === "#" || this.UserObject.branchCode === "" || this.UserObject.branchCode === "null" || this.UserObject.branchCode === null ||this.UserObject.branchCode === undefined))
            {
              this.GetBranchPdt()
            }
            else{
              this.OpenPdt()
            }
      
    },
    GetBranchPdt()
    {
      this.IsPdt = true
      this.BranchModal = true
      this.IsPrintBarcode = false
      this.IsCamera = false
    },
    OpenPdt()
    {
      this.$router.push("Pdtscan");
    },
    CheckSalesBarnch()
    {
       this.UserObject = JSON.parse(localStorage.getItem('User')) 
       if(this.UserObject.userType !== "Administrator" && this.UserObject.branchCode !== "" && this.UserObject.branchCode !== "#" && this.UserObject.branchCode !== null && this.UserObject.branchCode !== "null")
       {
        localStorage.removeItem('CounterSaleDate')
        localStorage.removeItem('CounterSaleBranch')
        this.goSale()
       }
       else{
        this.goBranchSale()
       }
    },
    goSale()
    {
      this.$router.push("Sales");

    },
    goBranchSale()
    {
      this.$router.push("BranchwiseSales");

    },
    goSaleall()
    {
      this.$router.push("SalesAll");

    },
    OpenSales()
    {
      if(this.PermissionObject.includes('frmSaleReg') === true && this.PermissionObject.includes('frmCounterSaleSummary') === true )
      {
          this.IsShowAllSales = true
          this.saledialog=true
      }
      else{
        this.CheckSalesBarnch()
      }
      /* if(this.PermissionObject.includes('frmCounterSaleSummary') === true )
      {
          this.IsShowCounterSales = true
      }
      else{
        this.IsShowCounterSales = false
      } */
      
    },
    Preference()
    {
      this.$router.push("Preference");
    },
    Printbarcode()
    {

       this.BranchCode = localStorage.getItem('SystemBranch')
      this.UserObject = JSON.parse(localStorage.getItem('User')) 
            if(this.UserObject.userType === "Administrator" ||this.UserObject.branchCode === "#" || this.UserObject.branchCode === "" || this.UserObject.branchCode === "null" || this.UserObject.branchCode === null ||this.UserObject.branchCode === undefined)
            {
              this.GetBranchPrintBarcode()
            }
            else{
              this.OpenPrintBarcode()
            }
      
    },
    GetBranchPrintBarcode()
    {
      this.IsPrintBarcode = true
      this.BranchModal = true
      this.IsPdt = false
      this.IsCamera = false
    },
    OpenPrintBarcode()
    {
        this.$router.push("Printbarcode");
    },
    BarcodeReader()
    {
      /* this.BranchCode = localStorage.getItem('SystemBranch')
      this.UserObject = JSON.parse(localStorage.getItem('User')) 
      if(this.UserObject.userType === "Administrator" ||this.BranchCode === "#" || this.BranchCode === "" || this.BranchCode === "null" || this.BranchCode === null ||this.BranchCode === undefined)
      {
              this.GetBranchCamera()
      }
      else{
              this.OpenBarcodeReader()
      } */
        this.OpenBarcodeReader()
    },
    GetBranchCamera()
    {
        this.IsCamera = true
        this.BranchModal = true
    },
    OpenBarcodeReader()
    {
      this.IsCamera = false
          if (this.IsNativeFlutterApp === true) {
            //window.FromJavascriptScanner.postMessage('CamaraLaunchRequist');
            this.OpenBarcodeReaderFlutter()
          } 
          else
          {
             this.BarcodeModal = true
          }
    },
    onDecode(result)
    {
           localStorage.setItem("barcode", result);
            this.$router.push("/BarcodeResult");
    },
    OpenBarcodeReaderFlutter() {
      // Call the Flutter handler to launch the barcode scanner
      window.flutter_inappwebview.callHandler('CamaraLaunchRequist')
        .then((result) => {
          if (result) {
            // Handle the barcode result
            //console.log('Barcode scanned:', result);
            //this.GetItemByBarcode(result)
            localStorage.setItem("barcode", result);
            this.$router.push("/BarcodeResult");

          } else {
            console.log('Barcode scanning cancelled or failed');
          }
        })
        .catch((error) => {
          console.error('Error launching barcode scanner:', error);
        });
    },
    GetBranchByBranchCode()
    {
      this.Loaderdialog = true
      axios
          .get(this.bURL+"/api/Branch/GetBranchByBranchCode?BranchCode=" +
            this.BranchCode )
          .then(
            (response) => {
              this.Loaderdialog = false
              this.PriceGroupId = response.data.PriceGroupId
              localStorage.setItem("PriceGroupId",this.PriceGroupId)
              this.BranchModal = false
              if(this.IsPdt === true)
              {
               this.OpenPdt()
              }
              if(this.IsPrintBarcode === true)
              {
               this.OpenPrintBarcode()
              }
              if(this.IsCamera === true)
              {
                this.OpenBarcodeReader()
              }
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },
    OpenVerificationForm(){
      this.$router.push("VerifyVoucher");
    }
    ,
      VoucherRegister() {
        localStorage.removeItem('VoucherType')
      this.$router.push("VoucherRegister");
    },
  }
   
  }
  </script>
  
  